import { useState } from 'react';

const faqs = [
  {
    question: '星空影院上的剧集都是免费观看的吗？',
    answer: '是的，星空影院聚合了大量免费高清剧集资源，包括热播电视剧、高分剧集全集，韩剧、美剧、国产剧等均可免费在线观看。我们致力于为广大追剧爱好者提供便捷、流畅的观影体验，无需付费即可享受超清画质。',
  },
  {
    question: '星空影院支持哪些设备观看？',
    answer: '星空影院全面支持PC端、平板电脑和手机端观看，响应式设计确保在不同屏幕尺寸下都能获得良好的观影体验。只需打开浏览器访问星空影院，即可随时随地追剧，无需下载额外APP。',
  },
  {
    question: '剧集画质如何？会卡顿缓冲吗？',
    answer: '我们提供超清画质播放，最高支持4K分辨率。星空影院采用先进的CDN加速技术，确保在全球范围内都能流畅播放。只要您的网络环境稳定，基本不会出现卡顿或缓冲的情况。',
  },
  {
    question: '韩剧和美剧有中文字幕吗？',
    answer: '当然有！星空影院上的所有韩剧、美剧、日剧、泰剧等海外剧集均配有中文字幕，部分热门剧集还提供双语字幕选项，让您追剧无障碍，轻松享受全球优质影视内容。',
  },
  {
    question: '星空影院的剧集更新频率如何？',
    answer: '我们每天更新50部以上的剧集内容，紧跟各大平台的播出节奏。热播韩剧、美剧通常在播出后24小时内即可在星空影院观看。您可以将星空影院加入收藏，随时获取最新剧集更新。',
  },
  {
    question: '如何快速找到想看的电视剧？',
    answer: '星空影院提供了便捷的分类导航和多维度筛选功能。您可以通过首页的分类浏览按地区（韩剧、美剧、国产剧等）筛选，也可以使用搜索功能直接查找剧名。高分榜单和热播推荐也能帮助您发现优质内容。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <section className="bg-background-100 py-14 md:py-20">
        <div className="max-w-[900px] mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              常见问题
            </h2>
            <p className="text-sm text-foreground-600 mt-2">关于星空影院的常见疑问解答</p>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="rounded-lg bg-background-50 border border-background-200 overflow-hidden"
              >
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center transition-transform duration-300 ${
                    openIndex === index ? 'rotate-45' : ''
                  }`}>
                    <i className="ri-add-line text-foreground-500"></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}